"use client"
import React from "react";
import ServiceProfileItemSummary from "@/components/locator/ServiceProfileItemSummary";
import PlaceTypeLabel from "@/components/shared/PlaceTypeLabel";
import "@/components/locator/LocatorSearchResultPreview.css";
import { Ratio } from "react-bootstrap";
import UralityImage from "@/components/shared/UralityImage";

const LocatorSearchResultPreview = ({
  item,
  selectedSearchOption,
  searchMode,
  showThumbnail,
  upperRight
}) => {
  return (
    <>
      <div className="locator-search-result-preview">
        <div className="left-side">
          <div className="locator-search-result-item-name">
            <h4 style={{ marginBottom: "0.25rem" }}>{item.displayName}</h4>
            {item.pinLayerPoint ? (
              <span>{item.pinLayerTitle}</span>
            ) : (
              searchMode === "business" && (
                <>
                  <PlaceTypeLabel values={item.types} />
                </>
              )
            )}
          </div>
          {item?.streetAddress && (
            <div>
              <span>
                <i className="fa-solid fa-location-pin"></i>
                &nbsp;&nbsp;{item?.streetAddress}
              </span>
            </div>
          )}
          {item?.addressLine1 && (
            <div>
              <span>
                <i className="fa-solid fa-location-pin"></i>
                &nbsp;&nbsp;{item?.addressLine1}
              </span>
            </div>
          )}
        </div>
        <div className="right-side">
          {showThumbnail ? (
            <Ratio aspectRatio="16x9" className="thumbnail">
              <UralityImage imageId={item.coverPhotoId} size="sm">
                {upperRight}
              </UralityImage>
            </Ratio>
          ) : (
            <>{upperRight}</>
          )}
        </div>
      </div>
      {searchMode === "service" && (
        <ServiceProfileItemSummary
          item={item}
          selectedSearchOption={selectedSearchOption}
          condensed={true}
          showNotes={true}
          shortNotes={true}
        />
      )}
    </>
  );
};

export default LocatorSearchResultPreview;
